import styled from 'styled-components'

const Flag = styled.img`
  height: 16px;
  margin-right: 8px;
  width: 16px;
`

export { Flag }
